export default {
  // Hero
  'home.greeting.morning': 'Buenos días, {name}',
  'home.greeting.afternoon': 'Buenas tardes, {name}',
  'home.greeting.evening': 'Buenas noches, {name}',
  'home.greeting.fallback': 'Hola',
  'home.greeting.morning.salute': 'Buenos días',
  'home.greeting.afternoon.salute': 'Buenas tardes',
  'home.greeting.evening.salute': 'Buenas noches',
  'home.eyebrow.today': 'Hoy es {date}',
  'home.summary.tasks': 'Tienes {count} tareas pendientes',
  'home.summary.tasks.zero': 'Sin tareas pendientes — todo al día',
  'home.summary.requests': '{count} solicitudes este mes',
  'home.summary.requests.zero': 'Aún no hay solicitudes este mes',
  'home.summary.requests.prev': '{count} solicitudes en el mes mostrado',
  'home.summary.requests.prev.zero': 'Sin solicitudes en el mes mostrado',
  'home.summary.requests.year': '{count} solicitudes este año',
  'home.summary.requests.year.zero': 'Aún no hay solicitudes este año',
  'home.period.month': 'Este mes',
  'home.period.previous': 'Mes anterior',
  'home.period.year': 'Este año',
  'home.period.aria': 'Selector de periodo',

  // KPI strip
  'home.kpi.requests': 'Solicitudes',
  'home.kpi.requests.prev': 'Solicitudes (mes anterior)',
  'home.kpi.requests.year': 'Solicitudes del año',
  'home.kpi.pending': 'Pendientes',
  'home.kpi.approved': 'Aprobadas',
  'home.kpi.problems': 'Rechazadas',
  'home.kpi.delta.up': '+{value}% vs mes anterior',
  'home.kpi.delta.down': '{value}% vs mes anterior',
  'home.kpi.delta.flat': 'Sin cambios vs mes anterior',
  'home.kpi.viewBreakdown': 'Ver desglose completo',
  'home.kpi.aria': 'Indicadores clave de solicitudes del periodo',

  // Quick launch
  'home.quickLaunch.title': 'Inicio rápido',
  'home.quickLaunch.subtitle': 'Tus procesos favoritos a un clic',
  'home.quickLaunch.empty':
    'Aún no tienes favoritos. Marca con estrella tus procesos en /processes para iniciarlos rápido desde aquí.',
  'home.quickLaunch.empty.cta': 'Ir a procesos',
  'home.quickLaunch.start': 'Iniciar',
  'home.quickLaunch.viewAll': 'Ver todos',

  // System health (admin)
  'home.systemHealth.title': 'Salud del sistema',
  'home.systemHealth.processes': 'Procesos activos',
  'home.systemHealth.users': 'Usuarios activos',
  'home.systemHealth.entities': 'Entidades activas',
  'home.systemHealth.documents': 'Documentos generados',

  // Plan limits (admin)
  'home.planLimits.title': 'Plan y consumo',
  'home.planLimits.subtitle': 'Uso actual contra los límites del plan',
  'home.planLimits.requests': 'Solicitudes',
  'home.planLimits.aiCredit': 'Crédito de IA',
  'home.planLimits.storage': 'Almacenamiento',
  'home.planLimits.emails': 'Correos enviados',
  'home.planLimits.documents': 'Documentos',
  'home.planLimits.warn': 'Cerca del límite',
  'home.planLimits.over': 'Sobre el plan',
  'home.planLimits.cta': 'Ver detalle del plan',
  'home.planLimits.usage': '{used} de {total}',
  'home.planLimits.unlimited': 'Sin límite',

  // AI consumption (admin)
  'home.ai.title': 'Consumo de IA',
  'home.ai.subtitle': 'Tokens consumidos este periodo',
  'home.ai.empty': 'Sin consumo de IA en este periodo.',
  'home.ai.viewAll': 'Ver todo el consumo',
  'home.ai.total': 'Total',
  'home.ai.creditOf': 'de {total}',

  // My activity (user)
  'home.myActivity.title': 'Mi actividad',
  'home.myActivity.subtitle': 'Distribución de mis solicitudes este periodo',
  'home.myActivity.empty': 'Aún no tienes actividad este periodo.',
  'home.myActivity.viewBreakdown': 'Ver los 8 estados',

  // Pending tasks
  'home.tasks.title': 'Tareas pendientes',
  'home.tasks.empty': 'No tienes tareas pendientes. ¡Buen trabajo!',
  'home.tasks.viewAll': 'Ir a tareas',
  'home.tasks.count': '{count} tareas',
  'home.tasks.count.one': '1 tarea',

  // Last requests
  'home.lastRequests.title': 'Últimas solicitudes',
  'home.lastRequests.subtitle': 'Las más recientes este periodo',
  'home.lastRequests.empty': 'Aún no se han enviado solicitudes en este periodo.',
  'home.lastRequests.viewAll': 'Ver todas',

  // Most used
  'home.mostUsed.title': 'Procesos más usados',
  'home.mostUsed.subtitle': 'Los procesos con mayor actividad este periodo',
  'home.mostUsed.empty': 'Sin actividad de procesos en este periodo.',
  'home.mostUsed.start': 'Iniciar',
  'home.mostUsed.viewAll': 'Ver todos',
  'home.mostUsed.usage': '{count} solicitudes',
  'home.mostUsed.usage.one': '1 solicitud',

  // Partners
  'home.partners.title': 'Principales colaboradores',
  'home.partners.subtitle': 'Top 5 con más actividad este periodo',
  'home.partners.toggleShow': 'Mostrar',
  'home.partners.toggleHide': 'Ocultar',
  'home.partners.empty': 'Sin colaboradores externos en este periodo.',

  // Status breakdown
  'home.breakdown.title': 'Desglose completo de estados',
  'home.breakdown.subtitle': 'Distribución de las solicitudes en {period}',
  'home.breakdown.close': 'Cerrar',
  'home.breakdown.total': 'Total: {count}',

  // Status labels
  'home.status.total': 'Total',
  'home.status.sent': 'Enviadas',
  'home.status.received': 'Recibidas',
  'home.status.pending': 'Pendientes',
  'home.status.approved': 'Aprobadas',
  'home.status.rejected': 'Rechazadas',
  'home.status.error': 'Con error',
  'home.status.canceled': 'Canceladas',
  'home.status.voided': 'Anuladas',

  // Errors
  'home.error.title': 'No pudimos cargar esta sección',
  'home.error.retry': 'Reintentar',
};
